import React, { useState } from 'react';

const panelStyle = {
  width: 280,
  background: '#16213e',
  borderLeft: '1px solid #333',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
};

const applyBtnStyle = {
  padding: '8px 16px',
  background: '#0f3460',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 13,
  width: '100%',
  marginTop: 12,
};

const inputStyle = {
  width: 60,
  padding: '4px 6px',
  background: '#1a1a2e',
  color: '#eee',
  border: '1px solid #444',
  borderRadius: 4,
  fontSize: 12,
  textAlign: 'center',
};

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 8,
};

const labelStyle = {
  fontSize: 11,
  color: '#999',
  width: 50,
};

export default function ResizePanel({ editor }) {
  const [width, setWidth] = useState(800);
  const [height, setHeight] = useState(600);

  const handleApply = () => {
    editor.resize({ width: Number(width), height: Number(height) });
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 12px', fontSize: 14 }}>Resize</h3>
      <div style={rowStyle}>
        <span style={labelStyle}>Width</span>
        <input type="number" min={1} value={width} onChange={(e) => setWidth(e.target.value)} style={inputStyle} />
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Height</span>
        <input type="number" min={1} value={height} onChange={(e) => setHeight(e.target.value)} style={inputStyle} />
      </div>
      <button style={applyBtnStyle} onClick={handleApply}>Apply Resize</button>
    </div>
  );
}
